import { useMemo } from "react";

export const useMandatory = (value: any) => {
    return useMemo(() => {
        if ( !value ) return "Skal udfyldes";

        return undefined;
    }, [value]);
};
